// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clubParticipantsEditor {
  min-height: 100vh;
  background: #f7f8fa;
  padding: 24px 28px 88px;
  color: #263245;
}

.clubParticipantsEditor--embedded.clubParticipantsEditor--eventLayout {
  padding: 20px 24px;
}

.clubParticipantsEditor--eventLayout .clubParticipantsEditor__cardCopy {
  min-width: 0;
  flex: 1 1 auto;
}

.clubParticipantsEditor--eventLayout .clubParticipantsEditor__cardHead {
  padding: 18px 22px;
}

.clubParticipantsEditor__cardHead > .bEventParticipantsMode {
  margin: 0 0 0 auto;
  flex-shrink: 0;
}

.clubParticipantsEditor__cardHead .bEventParticipantsMode__btn {
  height: 32px;
  padding: 0 12px;
  font-size: 12px;
}

.clubParticipantsEditor--embedded.clubParticipantsEditor--eventLayout .clubTransferPage__footer {
  position: static;
  margin-top: 18px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

@media (max-width: 760px) {
  .clubParticipantsEditor--eventLayout .clubParticipantsEditor__cardHead {
    flex-wrap: wrap;
  }

  .clubParticipantsEditor__cardHead > .bEventParticipantsMode {
    width: 100%;
    margin: 8px 0 0;
  }

  .clubParticipantsEditor--embedded.clubParticipantsEditor--eventLayout {
    padding: 16px;
  }
}

.clubParticipantsEditor__teamHint {
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  line-height: 1.5;
}

.clubParticipantsEditor__teamPicker {
  padding: 24px 22px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}

.clubParticipantsEditor__teamLabel {
  display: block;
  margin: 0 0 8px;
  color: var(--text-strong, #142033);
  font-size: 13px;
  font-weight: 650;
}

.clubParticipantsEditor__importModes {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 22px;
}

.clubParticipantsEditor__importModes label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: min(100%, 400px);
  margin: 0;
  padding: 14px 16px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  cursor: pointer;
}

.clubParticipantsEditor__importModes label.is-selected {
  border-color: var(--blue-600, #227ebd);
  background: var(--blue-50, #eef6fc);
}

.clubParticipantsEditor__importModes input {
  margin-top: 3px;
  accent-color: var(--blue-600, #227ebd);
}

.clubParticipantsEditor__importModes strong,
.clubParticipantsEditor__importModes small,
.clubParticipantsEditor__importSummary > * {
  display: block;
}

.clubParticipantsEditor__importModes strong {
  font-size: 13px;
  color: var(--text-strong, #142033);
}

.clubParticipantsEditor__importModes small,
.clubParticipantsEditor__importSummary small {
  margin-top: 4px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  line-height: 1.5;
}

.clubParticipantsEditor__importSummary {
  padding: 14px 22px;
  border-bottom: 1px solid var(--border-subtle, #dbe3ec);
  background: var(--blue-50, #eef6fc);
  font-size: 13px;
  line-height: 1.6;
}

.clubParticipantsEditor__teamAutocomplete {
  display: block;
  width: 100%;
  max-width: 520px;
}

.clubParticipantsEditor__teamAutocomplete .eAutocompleteInput {
  width: 100%;
  height: 44px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: var(--surface-card, #fff);
  color: var(--text-strong, #142033);
  font-size: 14px;
}

.clubParticipantsEditor__teamHint {
  margin: 8px 0 0;
}

.clubParticipantsEditor__teamError {
  margin-top: 8px;
  color: var(--red-600, #c53030);
  font-size: 13px;
}

@media (max-width: 640px) {
  .clubParticipantsEditor__teamPicker {
    padding: 20px 16px;
  }
}
.clubParticipantsEditor__loadError {
  display: flex;
  min-height: 320px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
}
.clubParticipantsEditor__loadError span {
  color: #718096;
}
.clubParticipantsEditor__loadError div {
  display: flex;
  gap: 10px;
}
.clubParticipantsEditor__loadError button {
  min-height: 38px;
  padding: 0 16px;
  border: 1px solid #ccd4df;
  border-radius: 7px;
  background: #fff;
}
.clubParticipantsEditor__loadError .clubParticipantsEditor__save {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.clubParticipantsEditor__header {
  display: flex;
  align-items: center;
  gap: 14px;
}
.clubParticipantsEditor__header h1 {
  font-size: 24px;
  margin: 0;
}
.clubParticipantsEditor__header p {
  margin: 3px 0 0;
  color: #718096;
}
.clubParticipantsEditor__back {
  border: 0;
  background: transparent;
  font-size: 24px;
}
.clubParticipantsEditor__pending {
  margin-left: auto;
  color: #718096;
  font-size: 13px;
}
.clubParticipantsEditor__pending.is-dirty {
  border: 1px solid #f2c66d;
  background: #fff4d6;
  color: #8a5700;
}
.clubParticipantsEditor__toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
  margin: 22px 0 14px;
}
.clubParticipantsEditor__toolbar input,
.clubParticipantsEditor__toolbar select,
.clubParticipantsEditor__toolbar button {
  height: 38px;
  border: 1px solid #d7dce3;
  border-radius: 7px;
  background: #fff;
  padding: 0 12px;
  font-size: 13px;
}
.clubParticipantsEditor__toolbar > input {
  width: 260px;
}
.clubParticipantsEditor__columns {
  position: relative;
  margin-left: auto;
}
.clubParticipantsEditor__columnsMenu {
  position: absolute;
  right: 0;
  top: 44px;
  z-index: 5;
  width: 220px;
  padding: 10px;
  background: #fff;
  border: 1px solid #d7dce3;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(25, 35, 50, 0.15);
}
.clubParticipantsEditor__columnsMenu label {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px;
}
.clubParticipantsEditor__panels {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 92px minmax(0, 1fr);
  gap: 12px;
  min-height: 570px;
}
.clubParticipantsEditor__panels section {
  background: #fff;
  border: 1px solid #e0e4e9;
  border-radius: 10px;
  overflow: hidden;
}
.clubParticipantsEditor__panels h2 {
  height: 54px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  padding: 0 16px;
  border-bottom: 1px solid #e8ebef;
  font-size: 15px;
}
.clubParticipantsEditor__panels h2 b {
  font-size: 12px;
  background: #edf2f7;
  border-radius: 12px;
  padding: 3px 8px;
}
.clubParticipantsEditor__list {
  max-height: 620px;
  overflow: auto;
}
.clubParticipantsEditor__pageLoading {
  padding: 28px 16px;
  color: #718096;
  text-align: center;
}
.clubParticipantsEditor__pagination {
  display: flex;
  min-height: 52px;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 8px 12px;
  border-top: 1px solid #edf0f3;
  font-size: 12px;
}
.clubParticipantsEditor__pagination button {
  min-height: 32px;
  padding: 0 11px;
  border: 1px solid #ccd4df;
  border-radius: 6px;
  background: #fff;
}
.clubParticipantsEditor__pagination button:disabled {
  opacity: 0.45;
}
.clubParticipantsEditor__row {
  display: grid;
  grid-template-columns: 22px repeat(6, minmax(90px, 1fr));
  gap: 9px;
  align-items: center;
  min-height: 48px;
  padding: 7px 12px;
  border-bottom: 1px solid #edf0f3;
  font-size: 12px;
  cursor: pointer;
}
.clubParticipantsEditor__row:hover,
.clubParticipantsEditor__row.is-selected {
  background: #f0f6ff;
}
.clubParticipantsEditor__badge {
  display: inline-block;
  background: #eef2f7;
  border-radius: 12px;
  padding: 4px 8px;
  font-style: normal;
}
.clubParticipantsEditor__move {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}
.clubParticipantsEditor__move button {
  height: 38px;
  border: 1px solid #ccd4df;
  border-radius: 7px;
  background: #fff;
  font-size: 12px;
}
.clubParticipantsEditor footer {
  position: fixed;
  z-index: 4;
  left: 0;
  right: 0;
  bottom: 0;
  height: 68px;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  background: #fff;
  border-top: 1px solid #e0e4e9;
}
.clubParticipantsEditor footer button {
  height: 38px;
  padding: 0 18px;
  border: 1px solid #ccd4df;
  border-radius: 7px;
  background: #fff;
}
.clubParticipantsEditor footer .clubParticipantsEditor__save {
  background: var(--action-primary, #227ebd);
  color: #fff;
  border-color: var(--action-primary, #227ebd);
}

.clubParticipantsEditor footer .clubParticipantsEditor__save:hover:not(:disabled),
.clubParticipantsEditor__loadError .clubParticipantsEditor__save:hover:not(:disabled) {
  border-color: var(--action-primary-hover, #1a6da3);
  background: var(--action-primary-hover, #1a6da3);
}

.clubParticipantsEditor .bPagination__pages button.is-active {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}
.clubParticipantsEditor footer button:disabled {
  opacity: 0.5;
}

/* Club transfer workflows */
.clubParticipantsEditor--embedded {
  min-height: 0;
  padding: 0 0 86px;
  background: transparent;
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);
}

.clubParticipantsEditor--embedded .clubTransferPage__card {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0;
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
  background: var(--surface-card, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsHead {
  min-height: 68px;
  padding: 12px 16px;
}

.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsIcon {
  width: 38px;
  height: 38px;
  flex-basis: 38px;
  border-radius: 9px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsTitle {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 16px;
  font-weight: 800;
}

.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsSubtitle {
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
}

.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsDivider {
  margin: 0;
  background: var(--border-subtle, #e2e8f0);
}

.clubParticipantsEditor--embedded .clubParticipantsEditor__editorWrap {
  padding: 10px 8px;
}

@media (min-width: 901px) {
  .clubParticipantsEditor--embedded.clubInviteRecipientsEditor {
    display: flex;
    min-height: 0;
    flex: 1 1 auto;
    flex-direction: column;
    padding-bottom: 0;
    overflow: hidden;
  }

  .clubParticipantsEditor--embedded.clubInviteRecipientsEditor .clubTransferPage__card {
    display: flex;
    min-height: 0;
    flex: 1 1 auto;
    flex-direction: column;
    overflow: hidden;
  }

  .clubParticipantsEditor--embedded.clubInviteRecipientsEditor .clubParticipantsEditor__editorWrap {
    display: flex;
    width: 100%;
    min-width: 0;
    min-height: 0;
    flex: 1 1 auto;
    padding: 0;
    overflow: hidden;
  }

  .clubInviteRecipientsEditor .twoPanelEditor,
  .clubInviteRecipientsEditor .twoPanelEditor__desktopLayout {
    width: 100%;
    min-width: 0;
    min-height: 0;
    flex: 1 1 auto;
  }

  .clubInviteRecipientsEditor .twoPanelEditor {
    display: flex;
  }

  .clubInviteRecipientsEditor .twoPanelEditor__row {
    height: 100%;
    margin-right: 0;
    margin-left: 0;
  }

  .clubInviteRecipientsEditor .twoPanelEditor--sourceFirst .twoPanelEditor__panelCol {
    height: 100%;
    min-height: 0;
  }

  .clubParticipantsEditor--embedded.clubInviteRecipientsEditor .clubTransferPage__footer {
    position: relative;
    flex: 0 0 62px;
    height: 62px;
    margin: 5px 0 0;
    padding-right: 8px;
    padding-left: 8px;
  }
}

.clubInviteStats {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 5px;
  margin: 0;
}

.clubInviteStats__item {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 5px;
  padding: 0 9px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 999px;
  background: var(--surface-card, #fff);
  white-space: nowrap;
}

.clubInviteStats__item::before {
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  border-radius: 50%;
  background: var(--text-subtle, #94a3b8);
  content: '';
}

.clubInviteStats__item span {
  color: var(--text-muted, #64748b);
  font-size: 10.5px;
  font-weight: 700;
}

.clubInviteStats__item strong {
  color: var(--text-strong, #0f172a);
  font-size: 11px;
  font-weight: 800;
}

.clubInviteStats__item.isEligible::before,
.clubInviteStats__item.isSent::before {
  background: var(--action-primary, #227ebd);
}

.clubInviteStats__item.isAnswered::before {
  background: #16a34a;
}

.clubInviteStats__item.isWillSend {
  border-color: #bfdbfe;
  background: var(--blue-50, #eef6fc);
}

.clubInviteStats__item.isWillSend::before {
  background: var(--blue-600, #1a6da3);
}

.clubInviteStats__item.isUpdate {
  border-color: var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
}

.clubInviteStats__item.isUpdate::before {
  background: #f59e0b;
}

.clubParticipantsEditor--embedded .clubParticipantsEditor__pending {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  margin-left: auto;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 11.5px;
  font-weight: 750;
  white-space: nowrap;
}

.clubParticipantsEditor--embedded .clubParticipantsEditor__pending.is-dirty {
  border: 1px solid var(--amber-100, #ffe9c2);
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}

.clubTransferPage__capacityWarning {
  margin: 0 16px 12px;
  padding: 10px 12px;
  border: 1px solid #fecaca;
  border-radius: 8px;
  background: #fff1f2;
  color: #b42318;
  font-size: 12.5px;
  font-weight: 650;
}

.clubParticipantsEditor--embedded .clubTransferPage__footer {
  position: sticky;
  z-index: 25;
  right: auto;
  bottom: 0;
  left: auto;
  display: flex;
  width: auto;
  height: 70px;
  align-items: center;
  justify-content: flex-end;
  gap: 9px;
  margin: 16px -8px -20px;
  padding: 0 8px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  background: rgba(255, 255, 255, 0.97);
  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.06);
  backdrop-filter: blur(8px);
}

.clubParticipantsEditor--embedded .clubTransferPage__footer > div {
  min-width: 0;
  margin-right: auto;
  color: var(--text-muted, #64748b);
  font-size: 12.5px;
  font-weight: 600;
}

.clubParticipantsEditor--embedded .clubTransferPage__footer button,
.clubParticipantsEditor--embedded .clubParticipantsEditor__loadError button {
  height: 38px;
  padding: 0 16px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 700;
}

.clubParticipantsEditor--embedded .clubTransferPage__footer .clubParticipantsEditor__save,
.clubParticipantsEditor--embedded .clubParticipantsEditor__loadError .clubParticipantsEditor__save {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}

.clubParticipantsEditor--embedded .clubTransferPage__footer .clubParticipantsEditor__save:hover:not(:disabled),
.clubParticipantsEditor--embedded
  .clubParticipantsEditor__loadError
  .clubParticipantsEditor__save:hover:not(:disabled) {
  border-color: var(--blue-600, #1a6da3);
  background: var(--blue-600, #1a6da3);
}

.clubParticipantsEditor--embedded .clubTransferPage__footer button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.clubParticipantsEditor__errorIcon {
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #fff1f2;
  color: #b42318 !important;
  font-size: 18px;
  font-weight: 800;
}

.clubTransferModal .modal-content {
  overflow: hidden;
  border: 0;
  border-radius: 14px;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);
}

.clubTransferModal .modal-header {
  min-height: 62px;
  padding: 0 20px !important;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: #fff !important;
}

.clubTransferModal .modal-title {
  color: var(--text-strong, #0f172a) !important;
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif) !important;
  font-size: 19px !important;
  font-weight: 800 !important;
}

.clubTransferModal .modal-body {
  padding: 20px !important;
}

.clubTransferModal .modal-footer {
  min-height: 64px;
  padding: 12px 20px !important;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}

.clubTransferModal .modal-footer .btn {
  min-height: 38px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
}

.clubTransferModal .modal-footer .btn-primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}

.clubTransferExitModal .modal-footer .btn-primary {
  border-color: #dc2626;
  background: #dc2626;
}

.clubTransferExitModal .modal-footer .btn-primary:hover {
  border-color: #b91c1c;
  background: #b91c1c;
}

.clubTransferModal__message {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: var(--text-body, #334155);
}

.clubTransferModal__message > span {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 16px;
  font-weight: 800;
}

.clubTransferModal__message.isWarning > span {
  background: var(--amber-50, #fff6e6);
  color: var(--amber-700, #a85c07);
}

.clubTransferModal__message.isDanger > span {
  background: #fff1f2;
  color: #b42318;
}

.clubTransferModal__message strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
}

.clubTransferModal__message p {
  margin: 4px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.5;
}

.clubTransferModal__message button {
  min-height: 36px;
  margin-top: 14px;
  padding: 0 14px;
  border: 1px solid var(--action-primary, #227ebd);
  border-radius: 8px;
  background: var(--action-primary, #227ebd);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
}

@media (max-width: 700px) {
  .clubInviteStats {
    justify-content: flex-start;
  }

  .clubParticipantsEditor--embedded .clubParticipantsEditor__editorWrap {
    padding: 10px;
  }

  .clubParticipantsEditor--embedded .bSchoolTeamManager__participantsHead {
    align-items: flex-start;
  }

  .clubParticipantsEditor--embedded .clubParticipantsEditor__pending {
    align-self: center;
  }

  .clubParticipantsEditor--embedded .clubTransferPage__footer {
    margin-right: -4px;
    margin-left: -4px;
    padding-right: 8px;
    padding-left: 8px;
  }

  .clubParticipantsEditor--embedded .clubTransferPage__footer > div {
    display: none;
  }
}
@media (max-width: 1100px) {
  .clubParticipantsEditor__toolbar {
    flex-wrap: wrap;
  }
  .clubParticipantsEditor__columns {
    margin-left: 0;
  }
  .clubParticipantsEditor__panels {
    grid-template-columns: 1fr;
  }
  .clubParticipantsEditor__move {
    flex-direction: row;
  }
  .clubParticipantsEditor__row {
    overflow-x: auto;
  }
}

/* Match the event participant transfer editor */
.clubParticipantsEditor {
  --editor-border: var(--border-subtle, #dbe3ec);
  --editor-text: var(--text-strong, #142033);
  --editor-muted: var(--text-muted, #69778a);
  padding: 18px 22px 92px;
  background: var(--slate-25, #f8fafc);
}
.clubParticipantsEditor__header {
  min-height: 118px;
  padding: 20px 22px;
  border: 1px solid var(--editor-border);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}
.clubParticipantsEditor__header h1 {
  color: var(--editor-text);
  font-size: 20px;
  font-weight: 760;
}
.clubParticipantsEditor__header p {
  margin-top: 5px;
  color: var(--editor-text);
  font-size: 15px;
  font-weight: 700;
}
.clubParticipantsEditor__header small {
  display: block;
  margin-top: 6px;
  color: var(--editor-muted);
  font-size: 12.5px;
}
.clubParticipantsEditor__back {
  display: inline-flex;
  width: 36px;
  height: 36px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--editor-border);
  border-radius: 9px;
  color: var(--editor-text);
  font-size: 18px;
}
.clubParticipantsEditor__pending {
  padding: 5px 10px;
  border-radius: 999px;
  background: var(--slate-100, #eef3f7);
  color: var(--editor-muted);
  font-size: 11.5px;
  font-weight: 700;
}
.clubParticipantsEditor__card {
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid var(--editor-border);
  border-radius: 14px;
  background: #fff;
}
.clubParticipantsEditor__cardHead {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--editor-border);
}
.clubParticipantsEditor__cardHead h2 {
  margin: 0;
  color: var(--editor-text);
  font-size: 16px;
  font-weight: 760;
}
.clubParticipantsEditor__cardHead p {
  margin: 3px 0 0;
  color: var(--editor-muted);
  font-size: 12.5px;
}
.clubParticipantsEditor__cardIcon {
  display: inline-flex;
  width: 38px;
  height: 38px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: var(--blue-50, #eaf5fb);
  color: var(--blue-700, #18699f);
}
.clubParticipantsEditor__cardIcon svg {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.8;
  stroke-linecap: round;
  stroke-linejoin: round;
}
.clubParticipantsEditor__toolbar {
  margin: 0;
  padding: 12px 14px;
  border-bottom: 1px solid var(--editor-border);
  background: #fff;
}
.clubParticipantsEditor__toolbar input,
.clubParticipantsEditor__toolbar select,
.clubParticipantsEditor__toolbar button {
  height: 36px;
  border-color: var(--editor-border);
  border-radius: 9px;
  color: var(--editor-text);
  font-size: 12.5px;
  font-weight: 600;
}
.clubParticipantsEditor__panels {
  min-height: 560px;
  padding: 14px;
  grid-template-columns: minmax(0, 1fr) 64px minmax(0, 1fr);
  gap: 0;
}
.clubParticipantsEditor__panels section {
  border-color: var(--editor-border);
  border-radius: 0;
  box-shadow: none;
}
.clubParticipantsEditor__panels section:first-child {
  border-radius: 12px 0 0 12px;
}
.clubParticipantsEditor__panels section:last-child {
  border-radius: 0 12px 12px 0;
}
.clubParticipantsEditor__panels h2 {
  min-height: 56px;
  color: var(--editor-text);
  font-size: 14px;
  font-weight: 760;
}
.clubParticipantsEditor__panels h2 b {
  min-height: 22px;
  padding: 0 8px;
  line-height: 22px;
  color: var(--editor-muted);
  font-size: 11px;
}
.clubParticipantsEditor__move {
  padding: 142px 12px 0;
  justify-content: flex-start;
}
.clubParticipantsEditor__move button {
  width: 40px;
  height: 40px;
  padding: 0;
  border-color: var(--editor-border);
  border-radius: 10px;
  overflow: hidden;
  color: var(--blue-700, #18699f);
  font-size: 0;
}
.clubParticipantsEditor__move button:first-child::after {
  content: '→';
  font-size: 18px;
  font-weight: 800;
}
.clubParticipantsEditor__move button:last-child::after {
  content: '←';
  font-size: 18px;
  font-weight: 800;
}
.clubParticipantsEditor__move button:hover:not(:disabled) {
  border-color: var(--blue-300, #9dcced);
  background: var(--blue-50, #eaf5fb);
}
.clubParticipantsEditor__row {
  min-height: 48px;
  padding: 8px;
  border-bottom-color: #edf1f5;
  color: var(--editor-text);
  font-size: 12.5px;
}
.clubParticipantsEditor__row.is-selected {
  box-shadow: inset 3px 0 0 var(--blue-600, #227ebd);
  background: var(--blue-50, #eaf5fb);
}
.clubParticipantsEditor__pagination {
  min-height: 54px;
  color: var(--editor-muted);
}
.clubParticipantsEditor footer {
  height: 70px;
  border-top-color: var(--editor-border);
}
.clubParticipantsEditor footer button {
  height: 38px;
  border-color: var(--editor-border);
  border-radius: 9px;
  font-size: 13px;
  font-weight: 700;
}
@media (max-width: 991.98px) {
  .clubParticipantsEditor__panels {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .clubParticipantsEditor__panels section,
  .clubParticipantsEditor__panels section:first-child,
  .clubParticipantsEditor__panels section:last-child {
    border-radius: 12px;
  }
  .clubParticipantsEditor__move {
    padding: 0;
    flex-direction: row;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminView/Clubs/Clubs/ClubParticipantsEditor.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,+CAA+C;EAC/C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;;EAGE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,wDAAwD;EACxD,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,WAAW;EACX,4CAA4C;AAC9C;;AAEA;;EAEE,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;AACA;EACE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,8FAA8F;AAChG;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,UAAU;IACV,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,+CAA+C;EAC/C,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,0CAA0C;EAC1C,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,uBAAuB;EACvB,cAAc;EACd,mDAAmD;EACnD,qCAAqC;EACrC,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;;AAEA;;;;EAIE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;EAC7C,oFAAoF;EACpF,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA,gDAAgD;AAChD;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,0CAA0C;EAC1C,uBAAuB;EACvB,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6CAA6C;AAC/C;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;;;EAGE,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,yDAAyD;EACzD,MAAM;AACR;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;AACd;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,kDAAkD;EAClD,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;;;IAGE,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":[".clubParticipantsEditor {\n  min-height: 100vh;\n  background: #f7f8fa;\n  padding: 24px 28px 88px;\n  color: #263245;\n}\n\n.clubParticipantsEditor--embedded.clubParticipantsEditor--eventLayout {\n  padding: 20px 24px;\n}\n\n.clubParticipantsEditor--eventLayout .clubParticipantsEditor__cardCopy {\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.clubParticipantsEditor--eventLayout .clubParticipantsEditor__cardHead {\n  padding: 18px 22px;\n}\n\n.clubParticipantsEditor__cardHead > .bEventParticipantsMode {\n  margin: 0 0 0 auto;\n  flex-shrink: 0;\n}\n\n.clubParticipantsEditor__cardHead .bEventParticipantsMode__btn {\n  height: 32px;\n  padding: 0 12px;\n  font-size: 12px;\n}\n\n.clubParticipantsEditor--embedded.clubParticipantsEditor--eventLayout .clubTransferPage__footer {\n  position: static;\n  margin-top: 18px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n@media (max-width: 760px) {\n  .clubParticipantsEditor--eventLayout .clubParticipantsEditor__cardHead {\n    flex-wrap: wrap;\n  }\n\n  .clubParticipantsEditor__cardHead > .bEventParticipantsMode {\n    width: 100%;\n    margin: 8px 0 0;\n  }\n\n  .clubParticipantsEditor--embedded.clubParticipantsEditor--eventLayout {\n    padding: 16px;\n  }\n}\n\n.clubParticipantsEditor__teamHint {\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.clubParticipantsEditor__teamPicker {\n  padding: 24px 22px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubParticipantsEditor__teamLabel {\n  display: block;\n  margin: 0 0 8px;\n  color: var(--text-strong, #142033);\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.clubParticipantsEditor__importModes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 22px;\n}\n\n.clubParticipantsEditor__importModes label {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  width: min(100%, 400px);\n  margin: 0;\n  padding: 14px 16px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  cursor: pointer;\n}\n\n.clubParticipantsEditor__importModes label.is-selected {\n  border-color: var(--blue-600, #227ebd);\n  background: var(--blue-50, #eef6fc);\n}\n\n.clubParticipantsEditor__importModes input {\n  margin-top: 3px;\n  accent-color: var(--blue-600, #227ebd);\n}\n\n.clubParticipantsEditor__importModes strong,\n.clubParticipantsEditor__importModes small,\n.clubParticipantsEditor__importSummary > * {\n  display: block;\n}\n\n.clubParticipantsEditor__importModes strong {\n  font-size: 13px;\n  color: var(--text-strong, #142033);\n}\n\n.clubParticipantsEditor__importModes small,\n.clubParticipantsEditor__importSummary small {\n  margin-top: 4px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  line-height: 1.5;\n}\n\n.clubParticipantsEditor__importSummary {\n  padding: 14px 22px;\n  border-bottom: 1px solid var(--border-subtle, #dbe3ec);\n  background: var(--blue-50, #eef6fc);\n  font-size: 13px;\n  line-height: 1.6;\n}\n\n.clubParticipantsEditor__teamAutocomplete {\n  display: block;\n  width: 100%;\n  max-width: 520px;\n}\n\n.clubParticipantsEditor__teamAutocomplete .eAutocompleteInput {\n  width: 100%;\n  height: 44px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #142033);\n  font-size: 14px;\n}\n\n.clubParticipantsEditor__teamHint {\n  margin: 8px 0 0;\n}\n\n.clubParticipantsEditor__teamError {\n  margin-top: 8px;\n  color: var(--red-600, #c53030);\n  font-size: 13px;\n}\n\n@media (max-width: 640px) {\n  .clubParticipantsEditor__teamPicker {\n    padding: 20px 16px;\n  }\n}\n.clubParticipantsEditor__loadError {\n  display: flex;\n  min-height: 320px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 12px;\n}\n.clubParticipantsEditor__loadError span {\n  color: #718096;\n}\n.clubParticipantsEditor__loadError div {\n  display: flex;\n  gap: 10px;\n}\n.clubParticipantsEditor__loadError button {\n  min-height: 38px;\n  padding: 0 16px;\n  border: 1px solid #ccd4df;\n  border-radius: 7px;\n  background: #fff;\n}\n.clubParticipantsEditor__loadError .clubParticipantsEditor__save {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.clubParticipantsEditor__header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.clubParticipantsEditor__header h1 {\n  font-size: 24px;\n  margin: 0;\n}\n.clubParticipantsEditor__header p {\n  margin: 3px 0 0;\n  color: #718096;\n}\n.clubParticipantsEditor__back {\n  border: 0;\n  background: transparent;\n  font-size: 24px;\n}\n.clubParticipantsEditor__pending {\n  margin-left: auto;\n  color: #718096;\n  font-size: 13px;\n}\n.clubParticipantsEditor__pending.is-dirty {\n  border: 1px solid #f2c66d;\n  background: #fff4d6;\n  color: #8a5700;\n}\n.clubParticipantsEditor__toolbar {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin: 22px 0 14px;\n}\n.clubParticipantsEditor__toolbar input,\n.clubParticipantsEditor__toolbar select,\n.clubParticipantsEditor__toolbar button {\n  height: 38px;\n  border: 1px solid #d7dce3;\n  border-radius: 7px;\n  background: #fff;\n  padding: 0 12px;\n  font-size: 13px;\n}\n.clubParticipantsEditor__toolbar > input {\n  width: 260px;\n}\n.clubParticipantsEditor__columns {\n  position: relative;\n  margin-left: auto;\n}\n.clubParticipantsEditor__columnsMenu {\n  position: absolute;\n  right: 0;\n  top: 44px;\n  z-index: 5;\n  width: 220px;\n  padding: 10px;\n  background: #fff;\n  border: 1px solid #d7dce3;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(25, 35, 50, 0.15);\n}\n.clubParticipantsEditor__columnsMenu label {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 7px;\n}\n.clubParticipantsEditor__panels {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 92px minmax(0, 1fr);\n  gap: 12px;\n  min-height: 570px;\n}\n.clubParticipantsEditor__panels section {\n  background: #fff;\n  border: 1px solid #e0e4e9;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.clubParticipantsEditor__panels h2 {\n  height: 54px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  padding: 0 16px;\n  border-bottom: 1px solid #e8ebef;\n  font-size: 15px;\n}\n.clubParticipantsEditor__panels h2 b {\n  font-size: 12px;\n  background: #edf2f7;\n  border-radius: 12px;\n  padding: 3px 8px;\n}\n.clubParticipantsEditor__list {\n  max-height: 620px;\n  overflow: auto;\n}\n.clubParticipantsEditor__pageLoading {\n  padding: 28px 16px;\n  color: #718096;\n  text-align: center;\n}\n.clubParticipantsEditor__pagination {\n  display: flex;\n  min-height: 52px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 8px 12px;\n  border-top: 1px solid #edf0f3;\n  font-size: 12px;\n}\n.clubParticipantsEditor__pagination button {\n  min-height: 32px;\n  padding: 0 11px;\n  border: 1px solid #ccd4df;\n  border-radius: 6px;\n  background: #fff;\n}\n.clubParticipantsEditor__pagination button:disabled {\n  opacity: 0.45;\n}\n.clubParticipantsEditor__row {\n  display: grid;\n  grid-template-columns: 22px repeat(6, minmax(90px, 1fr));\n  gap: 9px;\n  align-items: center;\n  min-height: 48px;\n  padding: 7px 12px;\n  border-bottom: 1px solid #edf0f3;\n  font-size: 12px;\n  cursor: pointer;\n}\n.clubParticipantsEditor__row:hover,\n.clubParticipantsEditor__row.is-selected {\n  background: #f0f6ff;\n}\n.clubParticipantsEditor__badge {\n  display: inline-block;\n  background: #eef2f7;\n  border-radius: 12px;\n  padding: 4px 8px;\n  font-style: normal;\n}\n.clubParticipantsEditor__move {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n}\n.clubParticipantsEditor__move button {\n  height: 38px;\n  border: 1px solid #ccd4df;\n  border-radius: 7px;\n  background: #fff;\n  font-size: 12px;\n}\n.clubParticipantsEditor footer {\n  position: fixed;\n  z-index: 4;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 68px;\n  padding: 0 28px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  background: #fff;\n  border-top: 1px solid #e0e4e9;\n}\n.clubParticipantsEditor footer button {\n  height: 38px;\n  padding: 0 18px;\n  border: 1px solid #ccd4df;\n  border-radius: 7px;\n  background: #fff;\n}\n.clubParticipantsEditor footer .clubParticipantsEditor__save {\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  border-color: var(--action-primary, #227ebd);\n}\n\n.clubParticipantsEditor footer .clubParticipantsEditor__save:hover:not(:disabled),\n.clubParticipantsEditor__loadError .clubParticipantsEditor__save:hover:not(:disabled) {\n  border-color: var(--action-primary-hover, #1a6da3);\n  background: var(--action-primary-hover, #1a6da3);\n}\n\n.clubParticipantsEditor .bPagination__pages button.is-active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n.clubParticipantsEditor footer button:disabled {\n  opacity: 0.5;\n}\n\n/* Club transfer workflows */\n.clubParticipantsEditor--embedded {\n  min-height: 0;\n  padding: 0 0 86px;\n  background: transparent;\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, -apple-system, 'Segoe UI', sans-serif);\n}\n\n.clubParticipantsEditor--embedded .clubTransferPage__card {\n  width: 100%;\n  max-width: none;\n  margin: 0;\n  padding: 0;\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsHead {\n  min-height: 68px;\n  padding: 12px 16px;\n}\n\n.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsIcon {\n  width: 38px;\n  height: 38px;\n  flex-basis: 38px;\n  border-radius: 9px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsTitle {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsSubtitle {\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n}\n\n.clubParticipantsEditor--embedded .bSchoolTeamManager__participantsDivider {\n  margin: 0;\n  background: var(--border-subtle, #e2e8f0);\n}\n\n.clubParticipantsEditor--embedded .clubParticipantsEditor__editorWrap {\n  padding: 10px 8px;\n}\n\n@media (min-width: 901px) {\n  .clubParticipantsEditor--embedded.clubInviteRecipientsEditor {\n    display: flex;\n    min-height: 0;\n    flex: 1 1 auto;\n    flex-direction: column;\n    padding-bottom: 0;\n    overflow: hidden;\n  }\n\n  .clubParticipantsEditor--embedded.clubInviteRecipientsEditor .clubTransferPage__card {\n    display: flex;\n    min-height: 0;\n    flex: 1 1 auto;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .clubParticipantsEditor--embedded.clubInviteRecipientsEditor .clubParticipantsEditor__editorWrap {\n    display: flex;\n    width: 100%;\n    min-width: 0;\n    min-height: 0;\n    flex: 1 1 auto;\n    padding: 0;\n    overflow: hidden;\n  }\n\n  .clubInviteRecipientsEditor .twoPanelEditor,\n  .clubInviteRecipientsEditor .twoPanelEditor__desktopLayout {\n    width: 100%;\n    min-width: 0;\n    min-height: 0;\n    flex: 1 1 auto;\n  }\n\n  .clubInviteRecipientsEditor .twoPanelEditor {\n    display: flex;\n  }\n\n  .clubInviteRecipientsEditor .twoPanelEditor__row {\n    height: 100%;\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  .clubInviteRecipientsEditor .twoPanelEditor--sourceFirst .twoPanelEditor__panelCol {\n    height: 100%;\n    min-height: 0;\n  }\n\n  .clubParticipantsEditor--embedded.clubInviteRecipientsEditor .clubTransferPage__footer {\n    position: relative;\n    flex: 0 0 62px;\n    height: 62px;\n    margin: 5px 0 0;\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n}\n\n.clubInviteStats {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 5px;\n  margin: 0;\n}\n\n.clubInviteStats__item {\n  display: inline-flex;\n  min-height: 28px;\n  align-items: center;\n  gap: 5px;\n  padding: 0 9px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 999px;\n  background: var(--surface-card, #fff);\n  white-space: nowrap;\n}\n\n.clubInviteStats__item::before {\n  width: 6px;\n  height: 6px;\n  flex: 0 0 6px;\n  border-radius: 50%;\n  background: var(--text-subtle, #94a3b8);\n  content: '';\n}\n\n.clubInviteStats__item span {\n  color: var(--text-muted, #64748b);\n  font-size: 10.5px;\n  font-weight: 700;\n}\n\n.clubInviteStats__item strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 11px;\n  font-weight: 800;\n}\n\n.clubInviteStats__item.isEligible::before,\n.clubInviteStats__item.isSent::before {\n  background: var(--action-primary, #227ebd);\n}\n\n.clubInviteStats__item.isAnswered::before {\n  background: #16a34a;\n}\n\n.clubInviteStats__item.isWillSend {\n  border-color: #bfdbfe;\n  background: var(--blue-50, #eef6fc);\n}\n\n.clubInviteStats__item.isWillSend::before {\n  background: var(--blue-600, #1a6da3);\n}\n\n.clubInviteStats__item.isUpdate {\n  border-color: var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n}\n\n.clubInviteStats__item.isUpdate::before {\n  background: #f59e0b;\n}\n\n.clubParticipantsEditor--embedded .clubParticipantsEditor__pending {\n  display: inline-flex;\n  min-height: 26px;\n  align-items: center;\n  margin-left: auto;\n  padding: 0 10px;\n  border-radius: 999px;\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 11.5px;\n  font-weight: 750;\n  white-space: nowrap;\n}\n\n.clubParticipantsEditor--embedded .clubParticipantsEditor__pending.is-dirty {\n  border: 1px solid var(--amber-100, #ffe9c2);\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n\n.clubTransferPage__capacityWarning {\n  margin: 0 16px 12px;\n  padding: 10px 12px;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  background: #fff1f2;\n  color: #b42318;\n  font-size: 12.5px;\n  font-weight: 650;\n}\n\n.clubParticipantsEditor--embedded .clubTransferPage__footer {\n  position: sticky;\n  z-index: 25;\n  right: auto;\n  bottom: 0;\n  left: auto;\n  display: flex;\n  width: auto;\n  height: 70px;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 9px;\n  margin: 16px -8px -20px;\n  padding: 0 8px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  background: rgba(255, 255, 255, 0.97);\n  box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.06);\n  backdrop-filter: blur(8px);\n}\n\n.clubParticipantsEditor--embedded .clubTransferPage__footer > div {\n  min-width: 0;\n  margin-right: auto;\n  color: var(--text-muted, #64748b);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n\n.clubParticipantsEditor--embedded .clubTransferPage__footer button,\n.clubParticipantsEditor--embedded .clubParticipantsEditor__loadError button {\n  height: 38px;\n  padding: 0 16px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.clubParticipantsEditor--embedded .clubTransferPage__footer .clubParticipantsEditor__save,\n.clubParticipantsEditor--embedded .clubParticipantsEditor__loadError .clubParticipantsEditor__save {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n\n.clubParticipantsEditor--embedded .clubTransferPage__footer .clubParticipantsEditor__save:hover:not(:disabled),\n.clubParticipantsEditor--embedded\n  .clubParticipantsEditor__loadError\n  .clubParticipantsEditor__save:hover:not(:disabled) {\n  border-color: var(--blue-600, #1a6da3);\n  background: var(--blue-600, #1a6da3);\n}\n\n.clubParticipantsEditor--embedded .clubTransferPage__footer button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.clubParticipantsEditor__errorIcon {\n  display: inline-flex;\n  width: 38px;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #fff1f2;\n  color: #b42318 !important;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.clubTransferModal .modal-content {\n  overflow: hidden;\n  border: 0;\n  border-radius: 14px;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.22);\n}\n\n.clubTransferModal .modal-header {\n  min-height: 62px;\n  padding: 0 20px !important;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: #fff !important;\n}\n\n.clubTransferModal .modal-title {\n  color: var(--text-strong, #0f172a) !important;\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif) !important;\n  font-size: 19px !important;\n  font-weight: 800 !important;\n}\n\n.clubTransferModal .modal-body {\n  padding: 20px !important;\n}\n\n.clubTransferModal .modal-footer {\n  min-height: 64px;\n  padding: 12px 20px !important;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n\n.clubTransferModal .modal-footer .btn {\n  min-height: 38px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.clubTransferModal .modal-footer .btn-primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n\n.clubTransferExitModal .modal-footer .btn-primary {\n  border-color: #dc2626;\n  background: #dc2626;\n}\n\n.clubTransferExitModal .modal-footer .btn-primary:hover {\n  border-color: #b91c1c;\n  background: #b91c1c;\n}\n\n.clubTransferModal__message {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  color: var(--text-body, #334155);\n}\n\n.clubTransferModal__message > span {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 16px;\n  font-weight: 800;\n}\n\n.clubTransferModal__message.isWarning > span {\n  background: var(--amber-50, #fff6e6);\n  color: var(--amber-700, #a85c07);\n}\n\n.clubTransferModal__message.isDanger > span {\n  background: #fff1f2;\n  color: #b42318;\n}\n\n.clubTransferModal__message strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n}\n\n.clubTransferModal__message p {\n  margin: 4px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n.clubTransferModal__message button {\n  min-height: 36px;\n  margin-top: 14px;\n  padding: 0 14px;\n  border: 1px solid var(--action-primary, #227ebd);\n  border-radius: 8px;\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n@media (max-width: 700px) {\n  .clubInviteStats {\n    justify-content: flex-start;\n  }\n\n  .clubParticipantsEditor--embedded .clubParticipantsEditor__editorWrap {\n    padding: 10px;\n  }\n\n  .clubParticipantsEditor--embedded .bSchoolTeamManager__participantsHead {\n    align-items: flex-start;\n  }\n\n  .clubParticipantsEditor--embedded .clubParticipantsEditor__pending {\n    align-self: center;\n  }\n\n  .clubParticipantsEditor--embedded .clubTransferPage__footer {\n    margin-right: -4px;\n    margin-left: -4px;\n    padding-right: 8px;\n    padding-left: 8px;\n  }\n\n  .clubParticipantsEditor--embedded .clubTransferPage__footer > div {\n    display: none;\n  }\n}\n@media (max-width: 1100px) {\n  .clubParticipantsEditor__toolbar {\n    flex-wrap: wrap;\n  }\n  .clubParticipantsEditor__columns {\n    margin-left: 0;\n  }\n  .clubParticipantsEditor__panels {\n    grid-template-columns: 1fr;\n  }\n  .clubParticipantsEditor__move {\n    flex-direction: row;\n  }\n  .clubParticipantsEditor__row {\n    overflow-x: auto;\n  }\n}\n\n/* Match the event participant transfer editor */\n.clubParticipantsEditor {\n  --editor-border: var(--border-subtle, #dbe3ec);\n  --editor-text: var(--text-strong, #142033);\n  --editor-muted: var(--text-muted, #69778a);\n  padding: 18px 22px 92px;\n  background: var(--slate-25, #f8fafc);\n}\n.clubParticipantsEditor__header {\n  min-height: 118px;\n  padding: 20px 22px;\n  border: 1px solid var(--editor-border);\n  border-radius: 14px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n.clubParticipantsEditor__header h1 {\n  color: var(--editor-text);\n  font-size: 20px;\n  font-weight: 760;\n}\n.clubParticipantsEditor__header p {\n  margin-top: 5px;\n  color: var(--editor-text);\n  font-size: 15px;\n  font-weight: 700;\n}\n.clubParticipantsEditor__header small {\n  display: block;\n  margin-top: 6px;\n  color: var(--editor-muted);\n  font-size: 12.5px;\n}\n.clubParticipantsEditor__back {\n  display: inline-flex;\n  width: 36px;\n  height: 36px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--editor-border);\n  border-radius: 9px;\n  color: var(--editor-text);\n  font-size: 18px;\n}\n.clubParticipantsEditor__pending {\n  padding: 5px 10px;\n  border-radius: 999px;\n  background: var(--slate-100, #eef3f7);\n  color: var(--editor-muted);\n  font-size: 11.5px;\n  font-weight: 700;\n}\n.clubParticipantsEditor__card {\n  margin-top: 16px;\n  overflow: hidden;\n  border: 1px solid var(--editor-border);\n  border-radius: 14px;\n  background: #fff;\n}\n.clubParticipantsEditor__cardHead {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 18px;\n  border-bottom: 1px solid var(--editor-border);\n}\n.clubParticipantsEditor__cardHead h2 {\n  margin: 0;\n  color: var(--editor-text);\n  font-size: 16px;\n  font-weight: 760;\n}\n.clubParticipantsEditor__cardHead p {\n  margin: 3px 0 0;\n  color: var(--editor-muted);\n  font-size: 12.5px;\n}\n.clubParticipantsEditor__cardIcon {\n  display: inline-flex;\n  width: 38px;\n  height: 38px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 10px;\n  background: var(--blue-50, #eaf5fb);\n  color: var(--blue-700, #18699f);\n}\n.clubParticipantsEditor__cardIcon svg {\n  width: 20px;\n  height: 20px;\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.8;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.clubParticipantsEditor__toolbar {\n  margin: 0;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--editor-border);\n  background: #fff;\n}\n.clubParticipantsEditor__toolbar input,\n.clubParticipantsEditor__toolbar select,\n.clubParticipantsEditor__toolbar button {\n  height: 36px;\n  border-color: var(--editor-border);\n  border-radius: 9px;\n  color: var(--editor-text);\n  font-size: 12.5px;\n  font-weight: 600;\n}\n.clubParticipantsEditor__panels {\n  min-height: 560px;\n  padding: 14px;\n  grid-template-columns: minmax(0, 1fr) 64px minmax(0, 1fr);\n  gap: 0;\n}\n.clubParticipantsEditor__panels section {\n  border-color: var(--editor-border);\n  border-radius: 0;\n  box-shadow: none;\n}\n.clubParticipantsEditor__panels section:first-child {\n  border-radius: 12px 0 0 12px;\n}\n.clubParticipantsEditor__panels section:last-child {\n  border-radius: 0 12px 12px 0;\n}\n.clubParticipantsEditor__panels h2 {\n  min-height: 56px;\n  color: var(--editor-text);\n  font-size: 14px;\n  font-weight: 760;\n}\n.clubParticipantsEditor__panels h2 b {\n  min-height: 22px;\n  padding: 0 8px;\n  line-height: 22px;\n  color: var(--editor-muted);\n  font-size: 11px;\n}\n.clubParticipantsEditor__move {\n  padding: 142px 12px 0;\n  justify-content: flex-start;\n}\n.clubParticipantsEditor__move button {\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-color: var(--editor-border);\n  border-radius: 10px;\n  overflow: hidden;\n  color: var(--blue-700, #18699f);\n  font-size: 0;\n}\n.clubParticipantsEditor__move button:first-child::after {\n  content: '→';\n  font-size: 18px;\n  font-weight: 800;\n}\n.clubParticipantsEditor__move button:last-child::after {\n  content: '←';\n  font-size: 18px;\n  font-weight: 800;\n}\n.clubParticipantsEditor__move button:hover:not(:disabled) {\n  border-color: var(--blue-300, #9dcced);\n  background: var(--blue-50, #eaf5fb);\n}\n.clubParticipantsEditor__row {\n  min-height: 48px;\n  padding: 8px;\n  border-bottom-color: #edf1f5;\n  color: var(--editor-text);\n  font-size: 12.5px;\n}\n.clubParticipantsEditor__row.is-selected {\n  box-shadow: inset 3px 0 0 var(--blue-600, #227ebd);\n  background: var(--blue-50, #eaf5fb);\n}\n.clubParticipantsEditor__pagination {\n  min-height: 54px;\n  color: var(--editor-muted);\n}\n.clubParticipantsEditor footer {\n  height: 70px;\n  border-top-color: var(--editor-border);\n}\n.clubParticipantsEditor footer button {\n  height: 38px;\n  border-color: var(--editor-border);\n  border-radius: 9px;\n  font-size: 13px;\n  font-weight: 700;\n}\n@media (max-width: 991.98px) {\n  .clubParticipantsEditor__panels {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  .clubParticipantsEditor__panels section,\n  .clubParticipantsEditor__panels section:first-child,\n  .clubParticipantsEditor__panels section:last-child {\n    border-radius: 12px;\n  }\n  .clubParticipantsEditor__move {\n    padding: 0;\n    flex-direction: row;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
